import React,{useContext} from 'react';

import { Redirect } from "react-router-dom";

import {GameProvider} from './GameProvider';
import {useGetData} from '../data/DataController';
import {PlayerProvider} from './player/PlayerProvider';
import {ContextGlobal} from '../globalProvider';

import Puzzle from './puzzle/Puzzle';
import Folder from './folder/Folder';
import Score from './score/Score';
import Timer from './timer/Timer';

function GamePage({gameName}){
  const global = useContext(ContextGlobal);

  const puzzles = ['mosquito','combate','dengue','febre_amarela','zika','chikungunya'];

  return(
    <GameProvider initGame={{game:useGetData(gameName)}}>
       {
        (puzzles.includes(gameName))?
            
              <div className={(global.state.isMobile)?"gamePage column centerItens":"gamePage row spaceAroundContent"}>
                <PlayerProvider gameName = {{gameName}}>
                  <Folder/>
                  <Timer/>
                  <Score/>
                  <Puzzle />
                </PlayerProvider>
              </div>
            :<Redirect to={'/inicio'} />
      }
    </GameProvider>
  );
}

export default GamePage;
